import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "enterprise_requests",
    object: "enterprise_request",
    header: [
      { text: "Nombres", value: "first_name" },
      { text: "Apellidos", value: "last_name" },
      { text: "Email", value: "email" },
      { text: "Empresa", value: "enterprise_name" },
      { text: "País", value: "country_id" },
      { text: "Colaboradores", value: "number_of_collaborators" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    options: {
      sortBy: ["_id"],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
